import React, { Fragment, useEffect } from "react";
import { Field, useForm, useFormState } from "react-final-form";
import { OnChange } from "react-final-form-listeners";

// Web Final Form Components
import { FormGroup, Label, Col } from "reactstrap";
import { InputField, ReactSelect, ToggleField, required } from "modules/4_final_form/web";

// Mobile Final Form Components
import { InputField as MobileInputField } from "modules/4_final_form/mobile";
import { connect } from "react-redux";
import _ from "lodash";
import { getProjectVariationNumbers } from "modules/project/variation_numbers/actions";
import ProjectVariationNumberAddButton from "modules/project/variation_numbers/web/add_button";

export const ProjectVariationAttributes = ({ fieldName, namesUsed }) => {
  const form = useForm();

  return (
    <Fragment>
      <FormGroup row>
        <Label md={3}>Label</Label>
        <Col md={8}>
          <Field name={`${fieldName}.label`} component={InputField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Project Select Name</Label>
        <Col md={8}>
          <Field
            name={`${fieldName}.project_select_name`}
            component={InputField}
            validate={(value, values) => {
              if (!value) {
                return "is required";
              }
              if (namesUsed.includes(value)) {
                return "must be unique";
              }
            }}
            convertToLowerCase
            lettersOnly
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Variation Name</Label>
        <Col md={8}>
          <Field
            name={`${fieldName}.variation_name`}
            component={InputField}
            validate={(value, values) => {
              if (!value) {
                return "is required";
              }
              if (namesUsed.includes(value)) {
                return "must be unique";
              }
            }}
            convertToLowerCase
            lettersOnly
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Placeholder</Label>
        <Col md={8}>
          <Field name={`${fieldName}.placeholder`} component={InputField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Required Field</Label>
        <Col md={8}>
          <Field name={`${fieldName}.required`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Dashboard</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_dashboard`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Report</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_report`} component={ToggleField} />
        </Col>
      </FormGroup>
    </Fragment>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    projects: state.projects,
    project_variation_numbers: state.project_variation_numbers,
  };
};

export let ProjectVariationFieldForm = (props) => {
  const {
    label,
    placeholder,
    required: isRequired,
    preview,
    project_select_name,
    variation_name,
    prefixName,
    disabled,
    projects,
    project_variation_numbers,
  } = props;

  const form = useForm();
  const formState = useFormState();
  const getSelectedProject = _.get(formState, `values.${prefixName}.${project_select_name}`);
  const selectedProjectVariationNumbers = _.filter(project_variation_numbers, (p) => p.project_id == getSelectedProject);

  const projectVariationOptions = _.map(selectedProjectVariationNumbers, (p) => {
    return { value: p.id, label: p.display_name, isDisabled: true };
  });


  useEffect(() => {
    props.getProjectVariationNumbers(getSelectedProject);
  }, [getSelectedProject]);

  return (
    <Fragment>
      <FormGroup row>
        <Label md={2}>
          Project
          {isRequired && "*"}
        </Label>
        <Col md={10}>
          <Field
            name={`${prefixName}.${project_select_name}`}
            disabled={preview || disabled}
            component={ReactSelect}
            options={_.map(projects, (p) => {
              return { value: p.id, label: p.display_name };
            })}
            placeholder="Select Project"
            validate={isRequired && !preview ? required : null}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={2}>
          {label || "Variation Number"}

          <ProjectVariationNumberAddButton
            project_id={getSelectedProject}
            afterCreated={(values) => {
              const findVariationNumber = _.find(selectedProjectVariationNumbers, (p) => p.number == values.number);
              if (findVariationNumber) {
                form.change(`${prefixName}.${variation_name}`, findVariationNumber.id);
              }
            }}
          />
        </Label>
        <Col md={10}>
          <Field
            name={`${prefixName}.${variation_name}`}
            disabled={preview || disabled || !getSelectedProject}
            component={ReactSelect}
            options={projectVariationOptions}
            placeholder={getSelectedProject ? placeholder : "Select Project First"}
            validate={isRequired && !preview ? required : null}
          />
        </Col>
      </FormGroup>
    </Fragment>
  );
};
ProjectVariationFieldForm.defaultProps = {
  prefixName: "data",
};

ProjectVariationFieldForm = connect(mapStateToProps, { getProjectVariationNumbers })(ProjectVariationFieldForm);

export const MobileInputFieldForm = (props) => {
  const { label, placeholder, required: isRequired, preview, name, prefixName } = props;
  return (
    <Field
      label={label}
      name={`${prefixName}.${name}`}
      disabled={preview}
      component={MobileInputField}
      placeholder={placeholder}
      validate={isRequired && !preview ? required : null}
    />
  );
};
MobileInputFieldForm.defaultProps = {
  prefixName: "data",
};
